import { combineForms } from 'react-redux-form';

const initialLogin = {
  email: '',
  password: '',
};

const initialNewProject = {
  name: '',
  url: '',
  http_user: '',
  http_pass: ''
};

const initialNewFeed = {
  name: ''
};

const initialFeed = {
  url: '',
  notes: ''
}

const initialNewColumns = {
  keys: '',
  before: ''
}

const initialRemoveColumn = {
  key: ''
}

const initialSearchFilters = {
  field: 'address',
  operator: '=',
  value: ''
}

const initialUser = {
  name: '',
  email: '',
  account_id: '',
  account_name: '',
  role: 'user'
}

const formsReducer = combineForms({
  login: initialLogin,
  newProject: initialNewProject,
  feed: initialFeed,
  newFeed: initialNewFeed,
  newColumns: initialNewColumns,
  removeColumn: initialRemoveColumn,
  setFilters: initialSearchFilters,
  userForm: initialUser
}, 'deep')

export {
  initialLogin,
  initialNewProject,
  initialNewFeed,
  initialNewColumns,
  initialRemoveColumn,
  initialSearchFilters,
  initialUser
}

export default formsReducer



// WEBPACK FOOTER //
// ./src/js/reducers/formsReducer.js